// ============================================================
// MANIC MEETER — Deutsche Inhalte: der Kollege ohne Deutsch
// ============================================================
// Dave ist seit sieben Jahren im Münchner Büro und spricht kein Wort Deutsch.
// Seine Beiträge stehen daher auf Englisch — die Sprache, die der Spieler
// gerade *nicht* gewählt hat. Wer das Spiel auf Englisch stellt, trifft
// stattdessen Hans-Peter (siehe ../en/foreign.ts).

import type { ForeignColleagueContent } from "../contract";

export const FOREIGN_COLLEAGUE: ForeignColleagueContent = {
  name: "Dave",
  roleLabel: "Kollege aus dem London-Office",
  tenure: "seit 7 Jahren hier",
  subtitle: "[Übersetzung nicht verfügbar]",
  tooltip:
    "Dave wurde 2019 für sechs Monate aus London geschickt. Niemand hat ihn je zurückgerufen. "
    + "Deutschkurs war zweimal beantragt und zweimal budgetiert — den Antrag hat er nicht verstanden.",
  introduction:
    "🌍 <strong>Dave</strong> ist auch da. Dave ist seit sieben Jahren hier und spricht kein Deutsch. "
    + "Widersprochen hat ihm trotzdem noch nie jemand.",
  phrases: [
    "Sorry, I'll just say this in English — I think we're all aligned here?",
    "Quick one: is this the meeting about the thing, or the other thing?",
    "I've been here seven years. I've got a really good feeling about this one.",
    "Just to add a bit of colour from the London perspective — we did exactly this in 2019.",
    "I didn't catch any of that, but I fully agree with Klaus.",
    "Can we take a step back? I've lost the thread. To be fair, I lost it in 2021.",
    "Not to be that guy, but has anyone actually written this down?",
    "I'll circle back on that. I say that every week. Nobody has ever circled back.",
    "Sorry — 'Rückstellung'? Is that good or bad? I've been nodding at it for years.",
    "Look, at the end of the day, it's about the customer. I think. Is it?",
    "I did try Duolingo. I'm on a 4-day streak. Started in 2020.",
    "Everyone keeps saying 'genau'. I've started saying it too. It works every time.",
    "Can we park that? Sorry — can we... put it on a car park? Is that the word?",
    "I'm going to be honest, I thought this was the retro. I've been in the wrong room.",
    "My German is fine for the bakery. The bakery is where I peak.",
    "Right, so — action items. Who's got the actions? Is it me? It's usually not me.",
    "I've read the deck. I've read it in English. Which deck were we discussing?",
    "The AI translated the minutes for me. Apparently I volunteered for something.",
    "Sorry, I was on mute. Not on the call — in the room. I just wasn't talking.",
    "Honestly? Seven years and the only word I truly understand is 'Feierabend'.",
  ],
  addressPhrases: [
    "Sorry — what do you think? You look like you know.",
    "You've been quiet. Back me up here, would you?",
    "Help me out — did they just agree, or was that a complaint?",
    "You speak the language. What did he just say about me?",
    "Quick sanity check: am I still on the right agenda item?",
  ],
};
